import { ArrowRight, BadgeCheck, CreditCard, ShieldCheck, Sparkles } from 'lucide-react'
import { licenseDurationLabel } from '../lib/license'

export function LaunchOffer() {
  return <section className="launch-offer" id="precio" aria-labelledby="launch-offer-title">
    <div className="launch-offer-copy">
      <p className="eyebrow">OFERTA DE LANZAMIENTO</p>
      <h2 id="launch-offer-title">Una cuenta Google.<br /><i>Una licencia bajo control.</i></h2>
      <p>Una licencia por cuenta Google, válida durante {licenseDurationLabel}. Antes de pagar conectas y analizas el alcance real: puedes crear una copia, preparar una limpieza segura o ambas cosas.</p>
      <div className="offer-trust"><span><ShieldCheck size={15} /> Licencia de {licenseDurationLabel}</span><span><BadgeCheck size={15} /> Sin renovación automática</span><span><CreditCard size={15} /> Pago seguro con Stripe</span></div>
    </div>
    <div className="offer-card">
      <span className="offer-pill"><Sparkles size={14} /> PRECIO DE LANZAMIENTO</span>
      <div className="offer-price"><span className="offer-was">9,90 €</span><strong>4,90 €</strong><span>por 1 cuenta Google</span></div>
      <p className="offer-price-note">Licencia válida durante {licenseDurationLabel} desde el pago. Cuando caduque, podrás comprar una nueva; nunca se renueva ni se cobra automáticamente.</p>
      <ul>
        <li>Una cuenta Google por licencia</li>
        <li>Gmail, Drive y el flujo de Google Fotos</li>
        <li>Carpeta local, USB o NAS montado</li>
        <li>Copias y reintentos durante {licenseDurationLabel}</li>
      </ul>
      <a className="button button-primary" href="/copia">Empezar <ArrowRight size={17} /></a>
      <small>Oferta activa durante el lanzamiento. Después, el precio será 9,90 € por licencia de {licenseDurationLabel}.</small>
    </div>
  </section>
}
